exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submenu-title-noDropdown[data-v-70ad4e1c]{font-size:13px}", ""]);

// exports
